'use client';

export const isInIframe = typeof window === 'undefined' ? true : window.self !== window.top;
